import { isProduction } from "../helpers/application";

export const USERS = "users";
export const REWARDS = "rewards";
export const ESHOPS = "shops";
export const LOCKER = "locker";

const HOME_PATH = "/";

const REMOVE_TRAILING_SLASH_REGEX = /\/$/;
const removeTrailingSlash = (str) =>
  str === HOME_PATH ? str : str.replace(REMOVE_TRAILING_SLASH_REGEX, "");

export const LOCKER_PROD_URL = "https://app.bystadium.com/locker";
const REWARDS_PROD_URL = "https://rewards.bystadium.com";
export const ESHOPS_PROD_URL = "https://www.bystadium.com/shops";
export const USERS_PROD_URL = "https://account.bystadium.com";

export const LOCKER_NONPROD_URL = removeTrailingSlash(
  `${process.env.NEXT_PUBLIC_BYSTADIUM_DASHBOARD_HOSTNAME}/locker`,
);
const REWARDS_NONPROD_URL = removeTrailingSlash(process.env.NEXT_PUBLIC_STADIUM_REWARDS_URL || "");
export const ESHOPS_NONPROD_URL = removeTrailingSlash(
  process.env.NEXT_PUBLIC_STADIUM_ESHOPS_URL || "",
);
export const USERS_NONPROD_URL = removeTrailingSlash(
  process.env.NEXT_PUBLIC_STADIUM_USERS_URL || "",
);

export const POINTS_REWARDS_URL = isProduction ? REWARDS_PROD_URL : REWARDS_NONPROD_URL;

const PATHNAMES = {
  settings: {
    home: "/account/settings",
    addressBook: "/account/address-book",
    paymentMethods: "/account/payment-methods",
    advancedOptions: "/account/advanced-options",
    changePassword: "/account/change-password",
    emailPreferences: "/account/email-preferences",
    tasteProfile: "/account/taste-profile",
  },
  contacts: "/account/contacts",
  rewards: "/",
  eshops: {
    dashboard: "/dashboard",
    base: "/shops",
    home: "/shops",
    myShops: "/shops/[[...status]]",
    redeem: "/shops/redeem",
    shopPage: "/shops/[code]",
    myOrders: "/my-orders/purchases",
    integrations: "/integrations",
    availableShops: "/redeem",
    chooseTemplate: "/templates",
    createShop: "/create",
    editTemplate: "/create/edit-template",
    myFunds: "/my-funds",
    kits: "/kits",
  },
  wallet: "/wallet",
  locker: {
    listing: "/",
    savedListing: "/saved",
    inventory: "/inventory",
    restock: "/item/:productSlug/restock",
  },
  teams: "/teams",
};

export const { settings, contacts, rewards, eshops, wallet, locker, teams } = PATHNAMES;

export const SETTINGS_PATHNAMES = Object.values(settings);

export const LOCKER_PATHNAMES = [locker.listing, locker.savedListing];

export const walletUrl = `${process.env.NEXT_PUBLIC_STADIUM_USERS_URL}/wallet`;
export const addFundsUrl = `${walletUrl}?add-funds=true`;

export const ESHOPS_URL = process.env.NEXT_PUBLIC_STADIUM_ESHOPS_URL;
export const MYSHOPS_URL = `${ESHOPS_URL}/all`;
export const EDIT_ESHOPS_TEMPLATE_URL = `${ESHOPS_URL}${eshops.editTemplate}`;
export const CHOOSE_ESHOPS_TEMPLATE_URL = `${ESHOPS_URL}${eshops.chooseTemplate}`;
export const CREATE_ESHOPS_TEMPLATE_URL = `${ESHOPS_URL}${eshops.createShop}`;
export const MY_FUNDS_URL = `${ESHOPS_URL}${eshops.myFunds}`;
export const KITS_DASHBOARD_ROUTE = `${ESHOPS_URL}${eshops.kits}`;

export const STADIUM_TEAMS_URL = `${isProduction ? USERS_PROD_URL : USERS_NONPROD_URL}${teams}`;
export const STADIUM_WALLET_URL = `${isProduction ? USERS_PROD_URL : USERS_NONPROD_URL}${wallet}`;
export const STADIUM_LOCKER_LISTING_URL = `${isProduction ? LOCKER_PROD_URL : LOCKER_NONPROD_URL}${
  locker.listing
}`;
export const STADIUM_LOCKER_SAVED_LISTING_URL = `${
  isProduction ? LOCKER_PROD_URL : LOCKER_NONPROD_URL
}${locker.savedListing}`;

export const STADIUM_LOCKER_INVENTORY_URL = `${
  isProduction ? LOCKER_PROD_URL : LOCKER_NONPROD_URL
}${locker.inventory}`;

export const STADIUM_LOCKER_RESTOCK_URL = `${isProduction ? LOCKER_PROD_URL : LOCKER_NONPROD_URL}${
  locker.restock
}`;
